import { faCheckCircle } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { type PropsWithChildren, type ReactNode, useEffect } from "react";

import { T } from "@repo/transifex";

import { AnimatedButton } from "../animated-button";

type ScreenSuccessProps = PropsWithChildren<{
  onClose: () => void;
  footer?: ReactNode;
}>;

export const ScreenSuccess = ({
  onClose,
  children,
  footer
}: ScreenSuccessProps) => {
  useEffect(() => {
    const audioPlayer = new Audio("/audio/ticket-validation-success.wav");
    audioPlayer.play();
  }, []);

  return (
    <div className="flex h-full flex-col items-center justify-center bg-primary-dark">
      <FontAwesomeIcon
        icon={faCheckCircle}
        fontSize={250}
        className="text-white"
      />

      <div className="flex flex-col items-center justify-center gap-4 pb-12 pt-6">
        {children}
      </div>
      <AnimatedButton
        className="!rounded-xl !bg-white/10"
        overlayClassName="bg-white/30"
        onClick={onClose}
      >
        <T _str="Close" />
      </AnimatedButton>
      {footer ? <div className="mt-8 w-full px-8 pb-8">{footer}</div> : null}
    </div>
  );
};

export const ScreenSuccessTitle = ({ children }: PropsWithChildren) => {
  return <p className="text-7xl font-semibold text-white">{children}</p>;
};

export const ScreenSuccessText = ({ children }: PropsWithChildren) => {
  return <p className="text-2xl text-white">{children}</p>;
};
